import { render } from "./UpdateOverlay.vue?vue&type=template&id=06c1725b&scoped=true"
import script from "./UpdateOverlay.vue?vue&type=script&lang=js"
export * from "./UpdateOverlay.vue?vue&type=script&lang=js"

import "./UpdateOverlay.vue?vue&type=style&index=0&id=06c1725b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c1725b"]])

export default __exports__